const useCoursesTypes = () => {
    return {
        "GET_COURSES": "[Courses] => Get Courses",
        "GET_COURSE": "[Courses] => Get Course",
        "GET_RESOURCES": "[Courses] => Get Resources"
    };
}

export default useCoursesTypes;